TurnToWpJsonp([8],{

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_bar_html__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_bar_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_bar_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_bar_scss__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_bar_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__progress_bar_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {};
    },
    props: {
        minValue: {
            type: Number,
            default: 0
        },
        maxValue: { type: Number },
        value: { type: Number }
    },
    computed: {
        progressPercent: function () {
            if (this.maxValue) {
                return ((this.value - this.minValue) / (this.maxValue - this.minValue)) * 100;
            }
            return 0;
        },
        progressStyles: function () {
            return { width: this.progressPercent + "%" };
        }
    }
})));


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tt-o-progress-bar" }, [
    _c("div", { staticClass: "tt-o-progress-bar__base" }, [
      _c("div", {
        staticClass: "tt-o-progress-bar__progress",
        style: _vm.progressStyles
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("1e9be594", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("1e9be594", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This mixin handles determining if the user swiped left or swipes right for a given
 * container.  The component using this mixin needs to call "registerTouchContainer"
 * to initialize the listener.  The component also needs to implement "swipeLeft()"" and
 * "swipeRight()" methods that this mixin will call when they happen.
 */
var MIN_SWIPE_DISTANCE = 75;
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function () {
        return {
            preventVertical: false,
            touchContainerEl: null,
            touchOffset: 0,
            touchStarted: false,
            touchStartX: 0,
            touchStartY: 0
        };
    },
    methods: {
        handleTouchstart: function (e) {
            this.touchStarted = true;
            this.touchStartX = e.changedTouches[0].clientX;
            this.touchStartY = e.changedTouches[0].clientY;
        },
        handleTouchend: function (e) {
            this.touchOffsetX = (this.touchStartX - e.changedTouches[0].clientX);
            this.touchOffsetY = (this.touchStartY - e.changedTouches[0].clientY);
            if (Math.abs(this.touchOffsetY) > Math.abs(this.touchOffsetX)) {
                return;
            }
            if (this.touchOffsetX > MIN_SWIPE_DISTANCE) {
                // this method should be implemented by the component using this mixin
                this.swipeLeft();
            }
            else if (this.touchOffsetX < -MIN_SWIPE_DISTANCE) {
                // this method should be implemented by the component using this mixin
                this.swipeRight();
            }
            this.touchStarted = false;
            this.touchStartX = 0;
        },
        handleTouchmove: function (e) {
            if (this.preventVertical) {
                e.preventDefault();
            }
        },
        // this should be called by the component using this mixin when the scrollable area is
        // mounted(visible)
        registerTouchContainer: function (containerEl) {
            if ('ontouchstart' in window) {
                this.touchContainerEl = containerEl;
                this.touchContainerEl.addEventListener('touchstart', this.handleTouchstart);
                this.touchContainerEl.addEventListener('touchend', this.handleTouchend);
                this.touchContainerEl.addEventListener('touchmove', this.handleTouchmove);
            }
        }
    },
    beforeDestroy: function () {
        if ('ontouchstart' in window && this.touchContainerEl) {
            this.touchContainerEl.removeEventListener('touchstart', this.handleTouchstart);
            this.touchContainerEl.removeEventListener('touchend', this.handleTouchend);
            this.touchContainerEl.removeEventListener('touchmove', this.handleTouchmove);
        }
    }
});


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "tt-o-gallery-item",
        style: _vm.galleryItemStyles,
        attrs: {
          href: "",
          title: _vm.linkTitle,
          "aria-hidden": _vm.isHidden,
          tabindex: _vm.tabIndex,
          "aria-haspopup": "dialog",
          rel: "nofollow"
        }
      },
      _vm.$listeners
    ),
    [
      _c("tt-media-thumb", {
        attrs: {
          altText: _vm.altText,
          media: _vm.mediaItem,
          size: _vm.mediaSize
        }
      }),
      _vm._v(" "),
      _vm.showCaption
        ? _c("div", { staticClass: "tt-o-gallery-item__caption" }, [
            _c(
              "span",
              { staticClass: "tt-o-gallery-item__caption-text" },
              [
                _vm._v(_vm._s(_vm.captionText)),
                _vm.truncatedText ? [_vm._v("…")] : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("time", { staticClass: "tt-o-gallery-item__date" }, [
              _vm._v(_vm._s(_vm.mediaItem.dateCreatedFormatted))
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("53a3274a", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("53a3274a", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),

/***/ 437:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showGallery,
          expression: "showGallery"
        }
      ],
      staticClass: "tt-c-gallery"
    },
    [
      _c("div", {
        staticClass: "tt-c-gallery__heading",
        class: { "tt-u-align-center": !_vm.paginationTop },
        domProps: {
          innerHTML: _vm._s(_vm.$msg("gallery.title", [_vm.total], _vm.total))
        }
      }),
      _vm._v(" "),
      _vm.paginationTop
        ? _c("tt-pagination", {
            staticClass: "tt-c-gallery__pagination--top",
            attrs: {
              currentPage: _vm.currentPage,
              total: _vm.paginationTotal,
              pageSize: _vm.imagesPerPage,
              useIcons: true,
              hidePageList: true,
              isButtonStyle: _vm.useButtonArrowStyle
            },
            on: { updatePage: _vm.pageChange }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-gallery__wrap" },
        [
          _c(
            "div",
            { ref: "galleryOuterEl", staticClass: "tt-c-gallery__outer" },
            [
              _c(
                "div",
                {
                  staticClass: "tt-c-gallery__inner",
                  style: _vm.galleryTransform
                },
                [
                  _vm._l(_vm.media, function(mediaItem, mediaIndex) {
                    return [
                      _c("tt-gallery-item", {
                        key: mediaItem.id,
                        attrs: {
                          mediaItem: mediaItem,
                          mediaSize: _vm.mediaSize,
                          columnSpacing: _vm.galleryConfig.columnSpacing,
                          isHidden: _vm.isItemHidden(mediaIndex),
                          showCaption: _vm.showCaptions,
                          truncateLength: _vm.galleryConfig.truncateLength
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.openModal(mediaIndex)
                          }
                        }
                      })
                    ]
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm.paginationAsOverlay
            ? _c("tt-pagination", {
                staticClass: "tt-c-gallery__pagination--overlay",
                style: { top: _vm.overlayBtnX + "px" },
                attrs: {
                  currentPage: _vm.currentPage,
                  total: _vm.paginationTotal,
                  pageSize: _vm.imagesPerPage,
                  useIcons: true,
                  hideBackNext: false,
                  hidePageList: true,
                  isButtonStyle: _vm.useButtonArrowStyle
                },
                on: { updatePage: _vm.pageChange }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.paginationBottom
        ? _c(
            "tt-pagination",
            {
              class: {
                "tt-c-gallery__pagination--bottom-no-progress": !_vm
                  .galleryConfig.showProgressBar
              },
              attrs: {
                currentPage: _vm.currentPage,
                total: _vm.paginationTotal,
                pageSize: _vm.imagesPerPage,
                useIcons: true,
                hideBackNext: !_vm.paginationBottom,
                hidePageList: true,
                isButtonStyle: _vm.useButtonArrowStyle
              },
              on: { updatePage: _vm.pageChange }
            },
            [
              _vm.galleryConfig.showProgressBar
                ? _c("tt-progress-bar", {
                    staticClass: "tt-c-gallery__pagination-progress-bar",
                    attrs: {
                      minValue: 1,
                      maxValue: _vm.numberOfPages,
                      value: _vm.currentPage
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.galleryConfig.showProgressBar && !_vm.paginationBottom
        ? _c("tt-progress-bar", {
            staticClass: "tt-c-gallery__progress-bar",
            attrs: {
              minValue: 1,
              maxValue: _vm.numberOfPages,
              value: _vm.currentPage
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("1fd7bb08", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("1fd7bb08", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),

/***/ 439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/ts-utils.ts
var ts_utils = __webpack_require__(9);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/services/media-service.ts
var media_service = __webpack_require__(124);

// EXTERNAL MODULE: ./src/init/config.ts
var config = __webpack_require__(3);

// CONCATENATED MODULE: ./src/store/gallery-widget-store.ts

/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
var gallery_widget_store_Store = /** @class */ (function () {
    function Store() {
        this.state = {
            skus: undefined,
            tags: undefined,
            onFinish: undefined
        };
        var clientGalleryConfig = config["b" /* turnToConfig */].gallery || {};
        this.state.skus = clientGalleryConfig.skus;
        this.state.tags = clientGalleryConfig.tags;
        this.state.onFinish = clientGalleryConfig.onFinish;
    }
    Object.defineProperty(Store.prototype, "skus", {
        get: function () {
            return this.state.skus;
        },
        set: function (skus) {
            this.state.skus = skus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "tags", {
        get: function () {
            return this.state.tags;
        },
        set: function (tags) {
            this.state.tags = tags;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "onFinish", {
        get: function () {
            return this.state.onFinish;
        },
        set: function (onFinish) {
            this.state.onFinish = onFinish;
        },
        enumerable: true,
        configurable: true
    });
    return Store;
}());

/* harmony default export */ var gallery_widget_store = (new gallery_widget_store_Store());

// EXTERNAL MODULE: ./src/mixins/swipe-mixin.ts
var swipe_mixin = __webpack_require__(319);

// EXTERNAL MODULE: ./src/objects/media/media-thumb.ts
var media_thumb = __webpack_require__(94);

// EXTERNAL MODULE: ./src/util/text-utils.ts
var text_utils = __webpack_require__(65);

// EXTERNAL MODULE: ./src/filters/format-name.ts
var format_name = __webpack_require__(32);

// EXTERNAL MODULE: ./src/util/media-utils.ts
var media_utils = __webpack_require__(30);

// EXTERNAL MODULE: ./src/components/gallery/gallery-item.html
var gallery_item = __webpack_require__(436);
var gallery_item_default = /*#__PURE__*/__webpack_require__.n(gallery_item);

// EXTERNAL MODULE: ./src/components/gallery/gallery-item.scss
var gallery_gallery_item = __webpack_require__(437);
var gallery_gallery_item_default = /*#__PURE__*/__webpack_require__.n(gallery_gallery_item);

// CONCATENATED MODULE: ./src/components/gallery/gallery-item.ts







/* harmony default export */ var components_gallery_gallery_item = (gallery_item_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return {}; },
    props: {
        columnSpacing: {
            type: Number,
            default: 4
        },
        isHidden: {
            type: Boolean,
            default: true
        },
        mediaItem: { type: Object },
        mediaSize: {
            type: Number,
            default: 0
        },
        showCaption: {
            type: Boolean,
            default: false
        },
        truncateLength: {
            type: Number,
            default: 200
        }
    },
    components: { 'tt-media-thumb': media_thumb["a" /* default */] },
    computed: {
        altText: function () {
            return this.$msg('media.submittedBy', [Object(format_name["a" /* default */])(this.mediaItem.user)]);
        },
        captionText: function () {
            if (this.truncatedText) {
                return this.truncatedText;
            }
            return this.mediaItem.text ? this.mediaItem.text.trim() : '';
        },
        galleryItemStyles: function () {
            return "width:" + this.mediaSize + "px;margin-right:" + this.columnSpacing + "px";
        },
        linkTitle: function () {
            var username = Object(format_name["a" /* default */])(this.mediaItem.user);
            var type = this.mediaItem.type === media_utils["e" /* TYPE_PHOTO */] ? 'photo' : 'video';
            return this.$msg("gallery.opensMediaModal." + type, [username]);
        },
        tabIndex: function () {
            return this.isHidden ? '-1' : '0';
        },
        truncatedText: function () {
            var caption = this.mediaItem.text ? this.mediaItem.text.trim() : '';
            if (caption) {
                return Object(text_utils["a" /* truncateText */])(caption, this.truncateLength, 9);
            }
            return '';
        }
    }
})));

// EXTERNAL MODULE: ./src/objects/pagination/pagination.ts
var pagination = __webpack_require__(35);

// EXTERNAL MODULE: ./src/objects/progress/progress-bar.ts
var progress_bar = __webpack_require__(309);

// EXTERNAL MODULE: ./src/components/gallery/gallery.html
var gallery = __webpack_require__(438);
var gallery_default = /*#__PURE__*/__webpack_require__.n(gallery);

// EXTERNAL MODULE: ./src/components/gallery/gallery.scss
var gallery_gallery = __webpack_require__(439);
var gallery_gallery_default = /*#__PURE__*/__webpack_require__.n(gallery_gallery);

// CONCATENATED MODULE: ./src/components/gallery/gallery.ts











/* harmony default export */ var components_gallery_gallery = __webpack_exports__["default"] = (gallery_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            currentPage: 1,
            debouncedLoadMedia: undefined,
            isFetching: false,
            galleryStore: gallery_widget_store,
            galleryWidth: 0,
            media: [],
            mediaSize: 0,
            offset: 0,
            overlayBtnX: 0,
            showCaptions: false,
            startingMediaModalIndex: 0,
            total: 0
        };
    },
    components: {
        'tt-gallery-item': components_gallery_gallery_item,
        'tt-pagination': pagination["a" /* default */],
        'tt-progress-bar': progress_bar["a" /* default */]
    },
    props: {
        galleryConfig: { type: Object },
        onFinish: { type: Function },
        skus: Array,
        tags: Array
    },
    mixins: [swipe_mixin["a" /* default */]],
    computed: {
        galleryTransform: function () {
            var pageDifferential = this.singleImageWidth * this.imagesPerPage;
            var translate = (this.currentPage - 1) * pageDifferential;
            return "width: " + this.mediaSize + "px; transform: translateX(-" + translate + "px);";
        },
        imagesPerPage: function () {
            return Math.floor(this.galleryWidth / this.singleImageWidth);
        },
        paginationBottom: function () {
            return this.galleryConfig.arrowLocation === 'bottom';
        },
        paginationAsOverlay: function () {
            return this.galleryConfig.arrowLocation === 'overlay';
        },
        paginationTop: function () {
            return this.galleryConfig.arrowLocation === 'top';
        },
        paginationTotal: function () {
            // Since we allow the first image of the next page to display as much as possible, it may
            // appear that it is actually on the current page. When it is on the next to the last page,
            // it doesn't make a lot of sense to have to scroll to the next page.
            // The purprose here is to "fool" the pagination into believing that there is one less,
            // so it doesn't have a last page to go to.
            if (this.mediaSize > 0 && this.imagesPerPage > 0 && this.imagesPerPage < this.total) {
                var spaceOver = this.galleryWidth - (this.imagesPerPage * this.singleImageWidth);
                var percentOver = ((this.mediaSize - spaceOver) / this.mediaSize) * 100;
                if (percentOver < 15) {
                    return this.total - 1;
                }
            }
            return this.total;
        },
        showGallery: function () {
            return this.media.length >= this.galleryConfig.minContentCount;
        },
        singleImageWidth: function () {
            return this.mediaSize + this.galleryConfig.columnSpacing;
        },
        numberOfPages: function () {
            return Math.ceil(this.paginationTotal / this.imagesPerPage);
        },
        useButtonArrowStyle: function () {
            return this.galleryConfig.arrowStyle === 'button';
        },
        visibleStartIndex: function () {
            return this.imagesPerPage * (this.currentPage - 1);
        },
        visibleEndIndex: function () {
            return this.visibleStartIndex + this.imagesPerPage;
        }
    },
    methods: {
        bindResize: function () {
            window.removeEventListener('resize', this.onResize, false);
            window.addEventListener('resize', this.onResize, false);
        },
        callOnFinish: function () {
            var _this = this;
            // if client provided an onFinish function
            if (this.onFinish) {
                this.$nextTick(function () {
                    _this.onFinish();
                });
            }
        },
        loadMedia: function () {
            this.debouncedLoadMedia();
        },
        loadMediaFn: function () {
            var _this = this;
            if (this.skus === undefined ||
                ((this.isFetching || !this.shouldLoadMedia()) && this.offset !== 0)) {
                return;
            }
            this.isFetching = true;
            var offsetBeforeCall = this.offset;
            Object(media_service["b" /* getMediaList */])(this.skus, this.tags, this.offset, this.galleryConfig).then(function (data) {
                // if the offset was changed during this call, most likely it was due to skus changing
                if (offsetBeforeCall !== _this.offset) {
                    return;
                }
                // in case offset was set back to zero and media not cleared out
                if (_this.offset === 0) {
                    _this.media = [];
                }
                _this.offset += media_service["a" /* GALLERY_FETCH_LIMIT */];
                // To help prevent accidental calls to the service, if we didn't get any items this time,
                // we can assume there are no more, so set to the current number of items, otherwise set
                // to the total the service returned unless it is more than max allowed.
                if (data.media.length === 0) {
                    _this.total = _this.media.length;
                }
                else if (data.total > _this.galleryConfig.maxContentToReturn) {
                    _this.total = _this.galleryConfig.maxContentToReturn;
                }
                else {
                    _this.total = data.total;
                }
                data.media.forEach(function (mediaItem) {
                    // since the "max" images allowed may cut the actual total short, need to make sure
                    // that the number of media items does not exceed that total
                    if (_this.media.length <= _this.total) {
                        _this.media.push(mediaItem);
                    }
                });
                if (_this.offset === media_service["a" /* GALLERY_FETCH_LIMIT */]) {
                    // just need to call when first page is loaded. Will also be called when 'skus' changes.
                    _this.callOnFinish();
                }
                if (_this.shouldLoadMedia()) {
                    // if we still don't have enough, load more (usually if user skipped ahead)
                    // need the timeout due to the debounce
                    setTimeout(function () { return _this.loadMedia(); }, 100);
                }
                _this.isFetching = false;
            }).catch(function () {
                _this.isFetching = false;
            });
        },
        isItemHidden: function (index) {
            return index < this.visibleStartIndex || index > this.visibleEndIndex;
        },
        openModal: function (mediaIndex) {
            var _this = this;
            // tslint:disable-next-line
            __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 443)).then(function (mediaModalLoader) {
                mediaModalLoader.default.load({
                    media: _this.media,
                    startingIndex: mediaIndex
                });
            });
        },
        onResize: Object(ts_utils["c" /* debounce */])(function cb() {
            // needed to use function cb() instead of () =>, so we have the proper context of "this".
            // using debounce so recalculate() isn't called until the event firing has stopped long enough
            this.recalculate();
        }, 100),
        pageChange: function (pageNum) {
            var _this = this;
            if (pageNum >= 1 && pageNum <= this.numberOfPages) {
                // setting the page first will allow the gallery to move and pagination page to change
                this.currentPage = pageNum;
                // TT-11856 - focus on other pagination button if reached beginning or end
                if (this.numberOfPages > 1 && pageNum === 1) {
                    dom_utils["a" /* default */].safeFocus(function () { return _this.$el.querySelector('.tt-o-pagination__next'); });
                }
                else if (pageNum === this.numberOfPages) {
                    dom_utils["a" /* default */].safeFocus(function () { return _this.$el.querySelector('.tt-o-pagination__back'); });
                }
                // we call this every time since it checks to see if more need to be loaded
                this.loadMedia();
            }
        },
        recalculate: function () {
            var _this = this;
            // if not on the 1st page, we want to "somewhat" maintain where the user was in the
            // pagination.  We will do this by making sure whatever item is currently displayed first,
            // is displayed as part of the page after recalculation.
            // First we need to find which item that is...
            var previousFirstIndex = this.imagesPerPage * (this.currentPage - 1);
            // then we recalculate the media size and width of the gallery
            this.galleryWidth = this.$el.clientWidth;
            // get the highest breakpoint where viewport is closest, but equal or above the
            // container width so we can get the media size
            var breakpoint = this.galleryConfig.breakpoints
                .filter(function (item) { return _this.galleryWidth >= item.viewport; })
                .sort(function (a, b) { return a.viewport > b.viewport ? -1 : 1; })[0];
            this.mediaSize = breakpoint.size;
            this.showCaptions = breakpoint.showCaptions;
            // now we can set the current page to something else if need be
            if (this.currentPage > 1) {
                // set the page to whatever page that previousFirstIndex is in
                this.currentPage = Math.ceil((previousFirstIndex + 1) / this.imagesPerPage);
            }
            if (this.paginationAsOverlay) {
                // when in overlay, this centers the buttons over the image (not including the captions)
                var btnSelectFn = function () { return _this.$el.querySelector('.tt-o-pagination__next'); };
                dom_utils["a" /* default */].whenElementIsVisible(btnSelectFn).then(function () {
                    var buttonHeight = _this.$el.querySelector('.tt-o-pagination__next').clientHeight;
                    _this.overlayBtnX = (_this.mediaSize / 2) - (buttonHeight / 2) + 4;
                });
            }
        },
        shouldLoadMedia: function () {
            // caclulate how many media items need to load knowing we want to stay 3 pages ahead
            var numOfItemsToLoad = (this.currentPage + 3) * this.imagesPerPage;
            // then determine if we need to load more...
            if (numOfItemsToLoad > this.total) {
                return this.total > this.media.length;
            }
            return numOfItemsToLoad > this.media.length;
        },
        swipeLeft: function () {
            // called from touch mixin, scrolling left means going forward
            this.pageChange(this.currentPage + 1);
        },
        swipeRight: function () {
            // called from touch mixin, scrolling right means going back
            this.pageChange(this.currentPage - 1);
        }
    },
    created: function () {
        // TT-11257 - setting on "this" instead of former way in which it was defined as a debounce
        // on the class.  Was conflicting when gallery was included in the page twice, standalone
        // and part of reviews summary
        this.debouncedLoadMedia = Object(ts_utils["c" /* debounce */])(this.loadMediaFn, 100);
        if (this.skus !== undefined) {
            this.loadMedia();
        }
    },
    mounted: function () {
        var _this = this;
        dom_utils["a" /* default */].whenElementIsVisible(function () { return _this.$el; }, 50).then(function () {
            _this.recalculate();
            _this.bindResize();
            // the register and preventVertical are in the swipe-mixin
            _this.preventVertical = true;
            _this.registerTouchContainer(_this.$refs.galleryOuterEl);
            // after mounted, wait a couple seconds, then load more to stay ahead
            if (_this.shouldLoadMedia()) {
                setTimeout(function () { return _this.loadMedia(); }, 3000);
            }
        });
    },
    watch: {
        skus: function () {
            this.offset = 0;
            this.currentPage = 1;
            this.media = [];
            this.loadMedia();
        }
    },
    beforeDestroy: function () {
        // shouldn't be called as it should always be around, but just in case
        window.removeEventListener('resize', this.onResize, false);
    }
})));


/***/ })

});


// WEBPACK FOOTER //
// gwmkkj4zilpBdkasite/js/gallery.8609ee55f25c4fe2b92c.js